import { TwcProduct } from '../../../twc-products';

export const RADAR_FCST_PRODUCT_DATA: TwcProduct = {
  id: 'radar-reflectivity',
  defaultProductId: 'radarFcst-boeing', // do not change
  productName: 'Weather-Radar-Forecast-TWC',
  label: 'Radar Reflectivity',
  weatherType: 'RADAR_FCST',
  description:
    'TWC product (raster, forecast) - Radar Reflectivity Forecast w/ Winter Overlay',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 15,
  forecastTimeSlicePeriod: 15,
  lodMax: 7,
  protocol: 'WebTile',
  flightLevelProductIds: {},
  zOrder: 90
};
